import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { trafficSourceTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const editTrafficSource = (
  data: trafficSourceTypes.EditTrafficSourceData
): Promise<{ trafficSource: trafficSourceTypes.TrafficSource }> => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/traffic-sources/${_id}`, { data: dataWithoutId });
};

type EditTrafficSourceOptions = {
  onSuccess: () => void;
  config?: MutationConfig<typeof editTrafficSource>;
};

export function useEditTrafficSource({ config = {}, onSuccess }: EditTrafficSourceOptions) {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries(['traffic-sources']);
      toasts.loadingToast.success('edit-traffic-source', 'Traffic source updated successfully');
      onSuccess();
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error('edit-traffic-source', serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-traffic-source', 'Updating traffic source...');
      config.onMutate?.(...args);
    },
    mutationFn: editTrafficSource,
  });
}
